export interface DisplayNoneProps {
  children: React.ReactNode;
  condition: boolean;
}

export const DisplayNone = ({ condition, children }: DisplayNoneProps) => {
  const style = { display: condition ? "none" : "block" };
  return <div style={style}>{children}</div>;
};
